import { geocoding } from "@maptiler/sdk";
import { useQuery } from "@tanstack/react-query";
import { MAPTILER_API_KEY } from "../constants/globals";

interface ReverseGeolocationResult {
    status: "NOT_AVAILABLE" | "LOADING" | "DONE";
    location?: string;
}

export const useReverseGeocoding = (
    location?: number[],
): ReverseGeolocationResult => {
    const reverseLocationQuery = useQuery({
        queryKey: ["reverseGeolocation", location],
        queryFn: async () => {
            if (!location) {
                return "";
            }
            const response = await geocoding.reverse(location, {
                apiKey: MAPTILER_API_KEY,
                language: "en",
                types: [
                    "municipality",
                    "county",
                    "subregion",
                    "region",
                    "country",
                ],
            });
            const { place_name } = response.features[0];
            return place_name;
        },
        enabled: !!(location && MAPTILER_API_KEY),
    });

    if (!MAPTILER_API_KEY || reverseLocationQuery.isError) {
        return {
            status: "NOT_AVAILABLE",
        };
    }

    if (reverseLocationQuery.isLoading || !reverseLocationQuery.data) {
        return {
            status: "LOADING",
        };
    }

    return {
        status: "DONE",
        location: reverseLocationQuery.data,
    };
};
